import React, { useState } from "react";
import Layout from "../components/layout";
import { Form, Row, Col, Input } from "antd";
import { ChromePicker } from "react-color";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

const Settings = () => {
  const [logoUrl, setLogoUrl] = useState("");
  const [sidebarColor, setSidebarColor] = useState("");
  const [showColorPicker, setShowColorPicker] = useState(false);

  const Navigate = useNavigate();

  const onChangeLogoUrl = (e) => setLogoUrl(e.target.files[0]);

  const onSubmitForm = async (e) => {
    const formData = new FormData();

    formData.append("logo", logoUrl);
    formData.append("sidebarColor", sidebarColor);

    console.log("logo info :", formData.get("logo"));

    axios
      .put(`{process.env.REACT_APP_API_URL}/auth/put-settings`, formData, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((response) => {
        if (response.data.success) {
          toast.success(response.data.message);
          Navigate("/");
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <Layout>
      <h1 className="page-title">Settings</h1>
      <hr />
      <Form
        layout="vertical"
        encType="multipart/form-data"
        onFinish={onSubmitForm}
      >
        <Row gutter={25}>
          <Col span={8} xs={24} sm={24} lg={8}>
            <Form.Item required label="Upload a logo" name="logo">
              <input type="file" name="logo" onChange={onChangeLogoUrl} />
            </Form.Item>
          </Col>
          <Col span={8} xs={24} sm={24} lg={8}>
            <Form.Item
              label="Sidebar color"
              name="sidebarColor"
              rules={[
                {
                  required: true,
                  message: "Please enter sidebar color",
                },
              ]}
            >
              <Input
                name="sidebarColor"
                required
                value={sidebarColor}
                onChange={(e) => setSidebarColor(e.target.value)}
                onFocus={() => setShowColorPicker(true)} // show color picker
              />
            </Form.Item>
            {showColorPicker && (
              <ChromePicker
                color={sidebarColor}
                onChange={(color) => setSidebarColor(color.hex)}
                onclose={() => setShowColorPicker(false)}
              />
            )}
          </Col>
        </Row>
        <button className="btn btn-primary" type="submit">
          Confirm Settings
        </button>
      </Form>
    </Layout>
  );
};

export default Settings;
